// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js!../../side-panels.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-history-panel-container-visible {
  border-right: 1px solid var(--border-color) !important;
}

.event-history-panel-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: flex-end;
}

.event-history-panel-scroll-container {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
  display: flex;
  flex-direction: column-reverse;
  padding: var(--side-panel-padding);
  gap: calc(var(--side-panel-padding) * 1.5);
}

.event-history-panel-item {
  display: flex;
  flex-direction: column;
  border-radius: var(--dialog-border-radius);
  border: 1px solid var(--extra-light-grey);
  user-select: text;
}

.event-history-panel-item-me {
  border: 1px solid var(--extra-light-blue-background-color);
}

.event-history-panel-item-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--input-element-gap);
  background-color: var(--extra-light-grey);
  border-top-left-radius: var(--dialog-border-radius);
  border-top-right-radius: var(--dialog-border-radius);
  padding: calc(var(--input-element-gap-small) / 2);
}

.event-history-panel-item-user {
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.event-history-panel-item-me .event-history-panel-item-user {
  color: var(--info-color);
}

.event-history-panel-item-me .event-history-panel-item-header {
  background-color: var(--extra-light-blue-background-color);
}

.event-history-panel-item-content {
  display: flex;
  flex-direction: row;
  gap: var(--side-panel-padding);
  padding: var(--input-element-gap-small);
  position: relative;

  > span {
    max-width: 100%;
    overflow-wrap: break-word;
  }
}

.event-history-panel-item-icon {
  margin: 0 var(--input-element-gap-small);
}

.event-history-panel-item-content .event-history-item-content-image {
  width: 100%;
  margin: 0;
  border-radius: var(--dialog-border-radius);
}

.event-history-panel-item-content:has(.event-history-item-content-image) {
  justify-content: center;
}

.event-history-panel-item-copy-button {
  position: absolute;
  bottom: var(--input-element-gap-small);
  right: var(--input-element-gap-small);
  stroke: var(--dialog-background-color);
  stroke-opacity: 0.75;
  stroke-width: 20;
  display: none;
}

.event-history-panel-item:hover .event-history-panel-item-copy-button {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/side-panels/event-history-list/event-history-panel/EventHistoryPanel.component.css"],"names":[],"mappings":"AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;EAC7B,yCAAyC;EACzC,mDAAmD;EACnD,oDAAoD;EACpD,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;;EAElB;IACE,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,qCAAqC;EACrC,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@import url(\"../../side-panels.css\");\n\n.event-history-panel-container-visible {\n  border-right: 1px solid var(--border-color) !important;\n}\n\n.event-history-panel-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  justify-content: flex-end;\n}\n\n.event-history-panel-scroll-container {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column-reverse;\n  padding: var(--side-panel-padding);\n  gap: calc(var(--side-panel-padding) * 1.5);\n}\n\n.event-history-panel-item {\n  display: flex;\n  flex-direction: column;\n  border-radius: var(--dialog-border-radius);\n  border: 1px solid var(--extra-light-grey);\n  user-select: text;\n}\n\n.event-history-panel-item-me {\n  border: 1px solid var(--extra-light-blue-background-color);\n}\n\n.event-history-panel-item-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--input-element-gap);\n  background-color: var(--extra-light-grey);\n  border-top-left-radius: var(--dialog-border-radius);\n  border-top-right-radius: var(--dialog-border-radius);\n  padding: calc(var(--input-element-gap-small) / 2);\n}\n\n.event-history-panel-item-user {\n  font-weight: bold;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.event-history-panel-item-me .event-history-panel-item-user {\n  color: var(--info-color);\n}\n\n.event-history-panel-item-me .event-history-panel-item-header {\n  background-color: var(--extra-light-blue-background-color);\n}\n\n.event-history-panel-item-content {\n  display: flex;\n  flex-direction: row;\n  gap: var(--side-panel-padding);\n  padding: var(--input-element-gap-small);\n  position: relative;\n\n  > span {\n    max-width: 100%;\n    overflow-wrap: break-word;\n  }\n}\n\n.event-history-panel-item-icon {\n  margin: 0 var(--input-element-gap-small);\n}\n\n.event-history-panel-item-content .event-history-item-content-image {\n  width: 100%;\n  margin: 0;\n  border-radius: var(--dialog-border-radius);\n}\n\n.event-history-panel-item-content:has(.event-history-item-content-image) {\n  justify-content: center;\n}\n\n.event-history-panel-item-copy-button {\n  position: absolute;\n  bottom: var(--input-element-gap-small);\n  right: var(--input-element-gap-small);\n  stroke: var(--dialog-background-color);\n  stroke-opacity: 0.75;\n  stroke-width: 20;\n  display: none;\n}\n\n.event-history-panel-item:hover .event-history-panel-item-copy-button {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
